import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    windowHeightOverEqual1280: boolean;
  }>()
  .create(({ windowHeightOverEqual1280 }) => {
    return {
      donutChartLegend: {
        minWidth: '10px',
        height: '100%',
        justifyContent: 'center',
        flex: 1
      },
      donutChartLegendItem: {
        display: 'flex',
        alignItems: 'center',
        flex: 1
      },
      donutChartLegendItemColorSwatch: {
        borderRadius: 0.5,
        marginRight: '0.5rem',
        flexShrink: 0,
        width: windowHeightOverEqual1280 ? 12 : 10,
        height: windowHeightOverEqual1280 ? 12 : 10
      },
      donutChartLegendItemContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer'
      },
      donutChartLegendItemCount: {
        fontSize: windowHeightOverEqual1280 ? 10 : 8,
        fontWeight: 600,
        textAlign: 'right',
        minWidth: 'fit-content',
        ml: 2
      },
      donutChartLegendItemName: {
        fontSize: windowHeightOverEqual1280 ? 12 : 10
      }
    };
  });

export default useStyles;
